import { connect } from 'react-redux';

import { ProductLineName } from '@/components/modals/SubmitOrder/types';
import { ProposalWithBom } from '@/controllers/Activity';
import { selectNewOpportunity } from '@/store/reducers/opportunities/selectors';
import { selectCalculatedTax, selectCreatedOrderId } from '@/store/reducers/orders/selectors';
import { selectProductLineName } from '@/store/reducers/products/selectors';
import { selectProposal } from '@/store/reducers/proposals/selectors';
import { selectHomeOwnerAddress } from '@/store/reducers/shipping-addreses/selectors';
import { AppState, ContactVm } from '@/types';

import { SuccessStep as Component } from './SuccessStep';

const mapStateToProps = (state: AppState) => ({
  calculatedTax: selectCalculatedTax(state),
  createdOrderId: selectCreatedOrderId(state),
  homeownerAddress: selectHomeOwnerAddress(state) as ContactVm,
  productLineName: selectProductLineName(state) as ProductLineName,
  proposal: selectProposal(state) as ProposalWithBom,
  opportunity: selectNewOpportunity(state),
});

export const SuccessStep = connect(mapStateToProps)(Component);
